import script from "./DestaquesCarousel.vue?vue&type=script&setup=true&lang=js"
export * from "./DestaquesCarousel.vue?vue&type=script&setup=true&lang=js"

import "./DestaquesCarousel.vue?vue&type=style&index=0&id=13700af5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13700af5"]])

export default __exports__